export default __webpack_public_path__ + "static/media/Tiny-Frogs-Taiwan-Zoo.f95ecfa2.jpg";